import React, { createContext, Dispatch, ReactNode, SetStateAction, use, useMemo, useState } from 'react';

type ReadonlyState = {
    readOnly: boolean;
    setReadOnly: Dispatch<SetStateAction<boolean>>;
};

export const ReadOnlyContext = createContext<ReadonlyState>({
    readOnly: false,
    setReadOnly: () => undefined,
});

export const ReadOnlyContextProvider = ({ children }: { children: ReactNode }) => {
    const [readOnly, setReadOnly] = useState<boolean>(false);

    return (
        <ReadOnlyContext
            value={useMemo(
                () => ({
                    readOnly,
                    setReadOnly,
                }),
                [readOnly, setReadOnly],
            )}
        >
            {children}
        </ReadOnlyContext>
    );
};

export const useReadOnlyContext = () => use(ReadOnlyContext);
